<template>
	<div>
		<!-- 中间部分 -->
		<div id="content" class="w">
			<!-- 限时抢购 -->
			<!-- <div class="over mt35">
				<div style="float:left;width:192px;background:#f00180;color:#ffffff;padding:28px 32px;">
					<h1 style="font-size:48px;line-height:70px;">限时抢购</h1>
					<span style="text-align:center;display:block;margin-top:44px;">
						<img src="../../assets/picture/index/shandian.png" alt="" width="31" height="53">
					</span>
					<p style="text-align:center;display:block;font-size:24px;margin-top:28px;">距本场结束</p>
					<div style="text-align:center;margin-top:16px;">
						<p style="font-size:24px;"><span style="padding:2px 5px;background:#000000;">06</span>:<span style="padding:2px 5px;background:#000000;">23</span>:<span style="padding:2px 5px;background:#000000;">30</span></p>
					</div>
				</div>
				<div style="overflow:hidden;display:block;background:#ffffff;padding:6px;">
					<div style="width:230px;float:left;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/product.png" alt="" style="float:left;">
							<span style="overflow: hidden;border-right: 1px solid #eee;height: 182px;display: block;margin-top: 38px;"></span>
							<div style="text-align:center;">
								<p style="font-size:18px;margin:15px 0px;">毒药二代飞机杯</p>
								<p style="color:#e91515">￥<span style="font-size:26px;font-weight:bold;">3666</span></p>
							</div>
						</a>
					</div>
					<div style="width:230px;float:left;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/product.png" alt="" style="float:left;">
							<span style="overflow: hidden;border-right: 1px solid #eee;height: 182px;display: block;margin-top: 38px;"></span>
							<div style="text-align:center;">
								<p style="font-size:18px;margin:15px 0px;">毒药二代飞机杯</p>
								<p style="color:#e91515">￥<span style="font-size:26px;font-weight:bold;">3666</span></p>
							</div>
						</a>
					</div>
					<div style="width:230px;float:left;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/product.png" alt="" style="float:left;">
							<span style="overflow: hidden;border-right: 1px solid #eee;height: 182px;display: block;margin-top: 38px;"></span>
							<div style="text-align:center;">
								<p style="font-size:18px;margin:15px 0px;">毒药二代飞机杯</p>
								<p style="color:#e91515">￥<span style="font-size:26px;font-weight:bold;">3666</span></p>
							</div>
						</a>
					</div>
					<div style="width:230px;float:left;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/product.png" alt="" style="float:left;">
							<span style="overflow: hidden;border-right: 1px solid #eee;height: 182px;display: block;margin-top: 38px;"></span>
							<div style="text-align:center;">
								<p style="font-size:18px;margin:15px 0px;">毒药二代飞机杯</p>
								<p style="color:#e91515">￥<span style="font-size:26px;font-weight:bold;">3666</span></p>
							</div>
						</a>
					</div>
				</div>
			</div> -->
			<!-- 领卷中心和充值中心 -->
			<!-- <div class="over mt35">
				<div class="background">
					<div style="padding:25px;overflow:hidden;">
						<h1 style="font-size:30px;color:#000000;float:left;">
							领券中心
							<p style="margin-top:6px;"><img src="../../assets/picture/index/line.png" alt=""></p>
						</h1>
						<p style="float:right;"><img src="../../assets/picture/index/more.png" alt=""></p>
					</div>
					<div style="padding:0px 82px;">
						<div style="margin:28px 0px;height:118px;">
							<div style="float:left;margin-right:20px;">
								<img src="../../assets/picture/index/tu1.png" alt="" style="border-radius: 12px;">
							</div>
							<div style="height:118px;">
								<p style="color:#f00180;margin-bottom:12px;height:50px;">￥<span style="font-size:60px;font-weight:500;">100</span></p>
								<p style="font-size:18px;color:#999999;margin-bottom:6px;">满400元可用</p>
								<p style="font-size:18px;color:#333333;font-weight: 600;">仅可购买男性品类产品</p>
							</div>
						</div>
						<div style="margin:28px 0px;">
							<div style="float:left;margin-right:20px;">
								<img src="../../assets/picture/index/tu1.png" alt="" style="border-radius: 12px;">
							</div>
							<div style="margin-top:20px;">
								<p style="color:#f00180;margin-bottom:12px;">￥<span style="font-size:72px;">100</span></p>
								<p style="font-size:18px;color:#999999;margin-bottom:6px;">满400元可用</p>
								<p style="font-size:18px;color:#333333;">仅可购买男性品类产品</p>
							</div>
						</div>
						<div style="margin:28px 0px;">
							<div style="float:left;margin-right:20px;">
								<img src="../../assets/picture/index/tu1.png" alt="" style="border-radius: 12px;">
							</div>
							<div style="margin-top:20px;">
								<p style="color:#f00180;margin-bottom:12px;">￥<span style="font-size:72px;">100</span></p>
								<p style="font-size:18px;color:#999999;margin-bottom:6px;">满400元可用</p>
								<p style="font-size:18px;color:#333333;">仅可购买男性品类产品</p>
							</div>
						</div>
					</div>
				</div>
				<div style="background:#ffffff;width:590px;height:624px;float:right;">
					<div style="padding:25px;overflow:hidden;">
						<h1 style="font-size:30px;color:#000000;float:left;">
							充值中心
							<p style="margin-top:6px;"><img src="../../assets/picture/index/line.png" alt=""></p>
						</h1>
						<p style="float:right;"><img src="../../assets/picture/index/more.png" alt=""></p>
					</div>
					<div style=" ">
						<div style="text-align:center;font-size:24px;margin-bottom:18px;">
							<p style="color:#999999;margin-bottom:10px;">MEMBER RECHARGE</p>
							<p style="color:#666666">【惊喜多多 优惠多多】</p>
						</div>
						<div style="padding:0 90px;text-align:center;margin-top:30px;">
							<p style="line-height:60px;font-size:36px;border:2px solid #f00180;border-radius:40px;margin-bottom:10px;">充值<span style="color:#f00;">100</span>元<span style="margin:0px 20px;background:#f00180;border-radius:50%;color:#ffffff;">送</span><span style="color:#f00;">10</span>元</p>
							<p style="line-height:60px;font-size:36px;border:2px solid #f00180;border-radius:40px;margin-bottom:10px;">充值<span style="color:#f00;">200</span>元<span style="margin:0px 20px;background:#f00180;border-radius:50%;color:#ffffff;">送</span><span style="color:#f00;">25</span>元</p>
							<p style="line-height:60px;font-size:36px;border:2px solid #f00180;border-radius:40px;margin-bottom:10px;">充值<span style="color:#f00;">300</span>元<span style="margin:0px 20px;background:#f00180;border-radius:50%;color:#ffffff;">送</span><span style="color:#f00;">50</span>元</p>
							<p style="line-height:60px;font-size:36px;border:2px solid #f00180;border-radius:40px;margin-bottom:10px;">充值<span style="color:#f00;">400</span>元<span style="margin:0px 20px;background:#f00180;border-radius:50%;color:#ffffff;">送</span><span style="color:#f00;">80</span>元</p>
							<p style="line-height:60px;font-size:36px;border:2px solid #f00180;border-radius:40px;margin-bottom:10px;">充值<span style="color:#f00;">500</span>元<span style="margin:0px 20px;background:#f00180;border-radius:50%;color:#ffffff;">送</span><span style="color:#f00;">100</span>元</p>
						</div>
						<div style="text-align:center;margin-top:24px;font-size:16px;font-weight:bold;">
							特价商品不参加活动，会员卡享受积分优惠
						</div>
						
					</div>
					<div style="width: 0;height: 0;border-color: #f00180 transparent;border-width:0px 0px 54px 54px;border-style:solid;"></div>
				</div>
			</div>

			<div class="over mt35">
				<div class="menu">
					<div style="text-align:center">
						<h1 style="font-size:32px;line-height: 60px;color:#333333;">掌柜力荐</h1>
						<p style="font-size:14px;color:#cccccc;">HOT SALE PRODUCT</p>
					</div>
					<div style="margin-top:28px;">
						<div>
							<img src="../../assets/picture/index/banner2.jpg" width="1200" alt="">
						</div>
						<div style="margin-top:10px;">
							<ul>
								<li style="float:left;margin-right:18px;"><img src="../../assets/picture/index/product2.png" alt="" style="border-radius:10px;"></li>
								<li style="float:left;margin-right:18px;"><img src="../../assets/picture/index/product2.png" alt="" style="border-radius:10px;"></li>
								<li style="float:left;margin-right:18px;"><img src="../../assets/picture/index/product2.png" alt="" style="border-radius:10px;"></li>
								<li style="float:left;margin-right:18px;"><img src="../../assets/picture/index/product2.png" alt="" style="border-radius:10px;"></li>
								<li style="float:left;margin-right:18px;"><img src="../../assets/picture/index/product2.png" alt="" style="border-radius:10px;"></li>
								<li style="float:left;margin-right:18px;"><img src="../../assets/picture/index/product2.png" alt="" style="border-radius:10px;"></li>
								<li style="float:left;"><img src="../../assets/picture/index/product2.png" alt="" style="border-radius:10px;"></li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="over mt35">
				<div class="menu">
					<div style="text-align:center">
						<h1 style="font-size:32px;line-height: 60px;color:#333333;">会员特惠</h1>
						<p style="font-size:14px;color:#cccccc;">MEMBER BENEFITS</p>
					</div>
					<div style="margin-top:28px;">
						<div class="tpbj">
							<a href="javascript:;" style="padding:40px;overflow: hidden;display: block;">
								<img src="../../assets/picture/index/ssb.png" alt="">
								<div style="text-align:center;margin-top:38px;">
									<p style="font-size:30px;color:#555555;margin-bottom:12px;">小软萌2代-伸缩棒</p>
									<p style="font-size:14px;color:#999999;margin-bottom:24px;">小姐姐萌智选择</p>
									<p class="btn-buy">即刻购买</p>
								</div>
							</a>
						</div>
						<div class="tpbj">
							<a href="javascript:;" style="padding:40px;overflow: hidden;display: block;">
								<img src="../../assets/picture/index/ssb.png" alt="">
								<div style="text-align:center;margin-top:38px;">
									<p style="font-size:30px;color:#555555;margin-bottom:12px;">小软萌2代-伸缩棒</p>
									<p style="font-size:14px;color:#999999;margin-bottom:24px;">小姐姐萌智选择</p>
									<p class="btn-buy">即刻购买</p>
								</div>
							</a>
						</div>
						<div class="tpbj">
							<a href="javascript:;" style="padding:40px;overflow: hidden;display: block;">
								<img src="../../assets/picture/index/ssb.png" alt="">
								<div style="text-align:center;margin-top:38px;">
									<p style="font-size:30px;color:#555555;margin-bottom:12px;">小软萌2代-伸缩棒</p>
									<p style="font-size:14px;color:#999999;margin-bottom:24px;">小姐姐萌智选择</p>
									<p class="btn-buy">即刻购买</p>
								</div>
							</a>
						</div>
						<div class="tpbj">
							<a href="javascript:;" style="padding:40px;overflow: hidden;display: block;">
								<img src="../../assets/picture/index/ssb.png" alt="">
								<div style="text-align:center;margin-top:38px;">
									<p style="font-size:30px;color:#555555;margin-bottom:12px;">小软萌2代-伸缩棒</p>
									<p style="font-size:14px;color:#999999;margin-bottom:24px;">小姐姐萌智选择</p>
									<p class="btn-buy">即刻购买</p>
								</div>
							</a>
						</div>
						<div class="tpbj">
							<a href="javascript:;" style="padding:40px;overflow: hidden;display: block;">
								<img src="../../assets/picture/index/ssb.png" alt="">
								<div style="text-align:center;margin-top:38px;">
									<p style="font-size:30px;color:#555555;margin-bottom:12px;">小软萌2代-伸缩棒</p>
									<p style="font-size:14px;color:#999999;margin-bottom:24px;">小姐姐萌智选择</p>
									<p class="btn-buy">即刻购买</p>
								</div>
							</a>
						</div>
						<div class="tpbj">
							<a href="javascript:;" style="padding:40px;overflow: hidden;display: block;">
								<img src="../../assets/picture/index/ssb.png" alt="">
								<div style="text-align:center;margin-top:38px;">
									<p style="font-size:30px;color:#555555;margin-bottom:12px;">小软萌2代-伸缩棒</p>
									<p style="font-size:14px;color:#999999;margin-bottom:24px;">小姐姐萌智选择</p>
									<p class="btn-buy">即刻购买</p>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="over mt35">
				<div style="background:#e4e4e4;padding:12px 18px;overflow: hidden;">
					<div class="left">
						<p style="float:left;"><img src="../../assets/picture/index/1F.png" alt=""></p>
						<p style="font-size:36px;line-height:36px;margin-left:58px;">男性用品</p>
					</div>
					<div class="right" style="line-height:36px;">
						<a class="gray" href="javascript:;" @click="$router.push({path:'/shop/shopsearch',query:{cate_id:6}})">飞机杯</a>
						<em class="vline">/</em>
						<a class="gray" href="javascript:;" @click="$router.push({path:'/shop/shopsearch',query:{cate_id:7}})">自感软胶</a>
						<em class="vline">/</em>
						<a class="gray" href="javascript:;" @click="$router.push({path:'/shop/shopsearch',query:{cate_id:10}})">阴臀倒模</a>
						<em class="vline">/</em>
						<a class="c9" href="javascript:;" @click="$router.push({path:'/shop/shopsearch',query:{cate_id:11}})">实体娃娃</a>
						<em class="vline">/</em>
						<a href="javascript:;" @click="$router.push({path:'/shop/catesearch',query:{title:'男用器具'}})" class="org" rel="nofollow">更多>></a>
					</div>
				</div>
				<div>
					<ul>
						<li><img src="../../assets/picture/index/banner3.jpg" alt=""></li>
					</ul>
				</div>
				<div style="margin-top:28px;">
					<div style="width:285px;height:auto;float:left;margin-right:12px;margin-bottom:20px;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/demo.jpg" width="285" alt="">
							<div style="background:#ffffff;padding-bottom:18px;">
								<p style="padding:12px 18px;font-size:16px;line-height:22px;">女用品震动棒高潮自慰器AV夫妻调情阴蒂女性私处性情趣用具可插入</p>
								<p class="btn-buy">了解更多</p>
							</div>
						</a>
					</div>
					<div style="width:285px;height:auto;float:left;margin-right:12px;margin-bottom:20px;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/demo.jpg" width="285" alt="">
							<div style="background:#ffffff;padding-bottom:18px;">
								<p style="padding:12px 18px;font-size:16px;line-height:22px;">女用品震动棒高潮自慰器AV夫妻调情阴蒂女性私处性情趣用具可插入</p>
								<p class="btn-buy">了解更多</p>
							</div>
						</a>
					</div>
					<div style="width:285px;height:auto;float:left;margin-right:12px;margin-bottom:20px;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/demo.jpg" width="285" alt="">
							<div style="background:#ffffff;padding-bottom:18px;">
								<p style="padding:12px 18px;font-size:16px;line-height:22px;">女用品震动棒高潮自慰器AV夫妻调情阴蒂女性私处性情趣用具可插入</p>
								<p class="btn-buy">了解更多</p>
							</div>
						</a>
					</div>
					<div style="width:285px;height:auto;float:left;margin-right:12px;margin-bottom:20px;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/demo.jpg" width="285" alt="">
							<div style="background:#ffffff;padding-bottom:18px;">
								<p style="padding:12px 18px;font-size:16px;line-height:22px;">女用品震动棒高潮自慰器AV夫妻调情阴蒂女性私处性情趣用具可插入</p>
								<p class="btn-buy">了解更多</p>
							</div>
						</a>
					</div>
					<div style="width:285px;height:auto;float:left;margin-right:12px;margin-bottom:20px;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/demo.jpg" width="285" alt="">
							<div style="background:#ffffff;padding-bottom:18px;">
								<p style="padding:12px 18px;font-size:16px;line-height:22px;">女用品震动棒高潮自慰器AV夫妻调情阴蒂女性私处性情趣用具可插入</p>
								<p class="btn-buy">了解更多</p>
							</div>
						</a>
					</div>
					<div style="width:285px;height:auto;float:left;margin-right:12px;margin-bottom:20px;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/demo.jpg" width="285" alt="">
							<div style="background:#ffffff;padding-bottom:18px;">
								<p style="padding:12px 18px;font-size:16px;line-height:22px;">女用品震动棒高潮自慰器AV夫妻调情阴蒂女性私处性情趣用具可插入</p>
								<p class="btn-buy">了解更多</p>
							</div>
						</a>
					</div>
					<div style="width:285px;height:auto;float:left;margin-right:12px;margin-bottom:20px;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/demo.jpg" width="285" alt="">
							<div style="background:#ffffff;padding-bottom:18px;">
								<p style="padding:12px 18px;font-size:16px;line-height:22px;">女用品震动棒高潮自慰器AV夫妻调情阴蒂女性私处性情趣用具可插入</p>
								<p class="btn-buy">了解更多</p>
							</div>
						</a>
					</div>
					<div style="width:285px;height:auto;float:left;margin-right:12px;margin-bottom:20px;">
						<a href="javascript:;">
							<img src="../../assets/picture/index/demo.jpg" width="285" alt="">
							<div style="background:#ffffff;padding-bottom:18px;">
								<p style="padding:12px 18px;font-size:16px;line-height:22px;">女用品震动棒高潮自慰器AV夫妻调情阴蒂女性私处性情趣用具可插入</p>
								<p class="btn-buy">了解更多</p>
							</div>
						</a>
					</div>
				</div>
			</div> -->

			<!-- <div class="hlock over mt35">
				<div class="lk_l left">
					<p class="ldok">●</p>
				</div>
				<div class="lk_r left" id="lk_r">
					<a href="javascript:;">
						<img src="../../assets/picture/category/1526543459486692174.jpg" width="250" height="150">
					</a>
					<a href="javascript:;">
						<img src="../../assets/picture/category/1558605179211702126.jpg" width="250" height="150">
					</a>
					<a href="javascript:;">
						<img src="../../assets/picture/category/1586863395094215929.jpg" width="250" height="150">
					</a>
					<a href="javascript:;">
						<img src="../../assets/picture/category/1559126839784698232.jpg" width="250" height="150">
					</a>
				</div>
			</div>
			<div class="w ov mt35">
				<div class="h_pic" id="h_pic">
					<a class="h_pa" href="javascript:;">
						<img src="../../assets/picture/category/20210910062126_27510.jpg" width="290" height="260">
					</a>
					<a class="h_pa h_pa2">
						<img src="../../assets/picture/category/1531824070958462033.jpg" width="590" height="260">
					</a>
					<a class="h_pa" href="javascript:;">
						<img src="../../assets/picture/category/20210910062203_80698.jpg" width="290" height="260">
					</a>
					<a class="h_pa" href="javascript:;">
						<img src="../../assets/picture/category/1541994513787729837.jpg" width="290" height="260">
					</a>
					<a class="h_pa" href="javascript:;">
						<img src="../../assets/picture/category/1575271542567877562.jpg" width="290" height="260">
					</a>
					<a class="h_pa" href="javascript:;">
						<img src="../../assets/picture/category/20210910062406_59470.jpg" width="290" height="260">
					</a>
					<a class="h_pa" href="javascript:;">
						<img src="../../assets/picture/category/20210910062457_12497.jpg" width="290" height="260">
					</a>
					<div class="clear"></div>
				</div>
			</div> -->
			<p class="clear lh35">&nbsp;</p>
			
			<!--one over-->
			<!-- <p class="lh35">&nbsp;</p> -->
			<!--cat begain-->
			<!-- <common-index></common-index> -->
			<div v-for="(item,index) in cate" :key="index">
				<div v-if="index + 1 != 4">
					<div class="h_tt over">
						<em class="flor left">{{ index + 1 }}F</em>
						<h2 class="left">
							<a class="h_ha" href="javascript:;">{{item.title}}</a>
							<!-- <em class="gray pl5 f16">WOMAN</em> -->
						</h2>
						<ul class="right">
							<li v-for="(it,int) in item.z.slice(0,3)" :key="int">
								<router-link :to="{path:'/shop/shopsearch', query:{cate_id:it.id}}" target="_blank">
									{{it.title}}
								</router-link>
							</li>
							<li>
								<router-link :to="{path:'/shop/shopsearch', query:{cate_id:item.id}}" target="_blank">
									更多>>
								</router-link>
							</li>
						</ul>
					</div>
					<div class="h_fl">
						<div class="h_cat">
							<h3 class="mb5">{{item.title}}</h3>
							<a v-for="(it,int) in item.z" :key="int" class="gray" href="javascript:;" @click="$router.push({path:'/shop/shopsearch',query:{cate_id:it.id}})">{{it.title}}</a> 
						</div>
						<a class="h_ff" href="javascript:;" @click="$router.push({path:'/shop/catesearch',query:{title:'女用器具'}})">
							<img alt="女性用品" src="https://s.cccgx.com/themes/v4/css/ft/f2.jpg" width="123" height="75">
						</a>
					</div>
					<div v-for="(shu,index1) in list" :key="index1">
						<div class="h_fm" v-on:mouseover="handleOver9($event,shu,index)" v-on:mouseout="handleOut9($event,shu,index)">
							<!-- <a href="javascript:;">
								<img src="../../assets/picture/category/1541994689188920261.jpg" width="400" height="390">
							</a> -->
							<router-link :to="{path:'/detail', query:{id:shu[index].i}}" target="_blank">
								<img :src="shu[index].img" width="400" height="400"  v-if="shu[index].flag"/>
								<img :src="shu[index].img9" width="400" height="400" v-else/>
							</router-link>
						</div>
						<div class="h_fr">
							<router-link class="f_aa" :to="{path:'/detail', query:{id:shu[index].id}}" target="_blank">
								<img :src="shu[index].img1" width="296" height="188" />
							</router-link>
							<router-link class="f_aa" :to="{path:'/detail', query:{id:shu[index].id1}}" target="_blank">
								<img :src="shu[index].img2" width="296" height="188" />
							</router-link>
							<router-link class="f_aa" :to="{path:'/detail', query:{id:shu[index].id2}}" target="_blank">
								<img :src="shu[index].img3" width="296" height="188" />
							</router-link>
							<router-link class="f_aa" :to="{path:'/detail', query:{id:shu[index].id3}}" target="_blank">
								<img :src="shu[index].img4" width="296" height="188" />
							</router-link>
						</div>
					</div>
					<p class="clear lh35">&nbsp;</p>
				</div>
				<div style="overflow: hidden;" v-else>
					<div class="ov w_hd" @click="ranking()">
						<a rel="nofollow" href="javascript:;">
							<img src="../../assets/picture/category/paihangbang.jpg" width="1190" height="90">
						</a>
					</div>
					<p class="clear lh35">&nbsp;</p>
					<div class="h_tt over">
						<em class="flor left">{{ index + 1 }}F</em>
						<h2 class="left">
							<a class="h_ha" href="javascript:;">{{item.title}}</a>
							<!-- <em class="gray pl5 f16">WOMAN</em> -->
						</h2>
						<ul class="right">
							<li v-for="(it,int) in item.z.slice(0,3)" :key="int">
								<router-link :to="{path:'/shop/shopsearch', query:{cate_id:it.id}}" target="_blank">
									{{it.title}}
								</router-link>
							</li>
							<li>
								<router-link :to="{path:'/shop/shopsearch', query:{cate_id:item.id}}" target="_blank">
									更多>>
								</router-link>
							</li>
						</ul>
					</div>
					<div class="h_fl">
						<div class="h_cat">
							<h3 class="mb5">{{item.title}}</h3>
							<a v-for="(it,int) in item.z" :key="int" class="gray" href="javascript:;" @click="$router.push({path:'/shop/shopsearch',query:{cate_id:it.id}})">{{it.title}}</a> 
						</div>
						<a class="h_ff" href="javascript:;" @click="$router.push({path:'/shop/catesearch',query:{title:'女用器具'}})">
							<img alt="女性用品" src="https://s.cccgx.com/themes/v4/css/ft/f2.jpg" width="123" height="75">
						</a>
					</div>
					<div class="h_sex" id="h_sex">
						<a href="/detail?id=316" class="hx_a" target="_blank"><img width="330" height="400" src="../../assets/img1/qqly/qingqu2.jpg"><p class="sx_t"></p></a>
						<a href="/detail?id=317" class="hx_a" target="_blank"><img width="330" height="400" src="../../assets/img1/qqly/qingqu3.jpg"><p class="sx_t"></p></a>
						<a href="/detail?id=318" class="hx_a" target="_blank"><img width="330" height="400" src="../../assets/img1/qqly/qingqu1.jpg"><p class="sx_t"></p></a>
					</div>
					<p class="clear lh35">&nbsp;</p>
				</div>
			</div>
			
			<p class="clear lh35">&nbsp;</p>
			<div class="w ov con brd" id="brd">
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/durex.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/leten.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/coc.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/mannuo.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/svakom.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/yadike.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/movo.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/guiruo.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/duizihate.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/uz.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/fun.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/xingse.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/siyi.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/1464249014082159888.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/gangben.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/tuocong.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/zini.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/leco.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">
					<img src="https://s.cccgx.com/data/brandlogo/zalo.jpg" width="60" height="60" class="brdg">
					<a class="brd_s" href="javascript:;">点击查看</a>
				</a>
				<a class="brda" href="javascript:;">查看更多品牌</a>
			</div>
			<p class="clear lh35">&nbsp;</p>
		</div>
		<pc-right-side></pc-right-side>
	</div>
</template>

<script>

import Common_index from "@/components/common/common-index.vue"
import Pc_right_side from "@/components/common/right-side.vue"

export default{
	components:{
		
		'common-index':Common_index,
		'pc-right-side': Pc_right_side
	},
	data(){
		return{
			//数据
            cate:[],
			category:[],
			flag:false,
			list:[
				[
					{
						
						i:'420',
						id:'349',
						id1:'284',
						id2:'416',
						id3:'420',
						flag:true,
						img9:require("../../assets/img1/nxyp1/xiaoyuzhou.jpg"),
						img:require("../../assets/img1/nxyp1/xiaoyuzhou.jpg"),
						img1:require("../../assets/img1/nxyp1/chanping1.jpg"),
						img2:require("../../assets/img1/nxyp1/chanping2.jpg"),
						img3:require("../../assets/img1/nxyp1/chanping4.jpg"),
						img4:require("../../assets/img1/nxyp1/chanping3.jpg")
					},
					{
						i:'100',
						id:'254',
						id1:'279',
						id2:'415',
						id3:'447',
						flag:true,
						img9:require("../../assets/img1/nxyp/xiaoruanmeng.jpg"),
						img:require("../../assets/img1/nxyp/xiaoruanmeng.jpg"),
						img1:require("../../assets/img1/nxyp/chanping5.jpg"),
						img2:require("../../assets/img1/nxyp/chanping6.jpg"),
						img3:require("../../assets/img1/nxyp/chanping7.jpg"),
						img4:require("../../assets/img1/nxyp/chanping8.jpg")
					},
					// {
					// 	i:'167',
					// 	id:'116',
					// 	id1:'167',
					// 	id2:'158',
					// 	id3:'128',
					// 	flag:true,
					// 	img9:require("../../assets/img1/byt/biyuntao6.gif"),
					// 	img:require("../../assets/img1/byt/biyuntao.png"),
					// 	img1:require("../../assets/img1/byt/chanping9.png"),
					// 	img2:require("../../assets/img1/byt/chanping10.png"),
					// 	img3:require("../../assets/img1/byt/chanping11.png"),
					// 	img4:require("../../assets/img1/byt/chanping12.png")
					// },
					{
						i:'290',
						id:'290',
						id1:'271',
						id2:'255',
						id3:'277',
						flag:true,
						img9:require("../../assets/img1/yszq/jiuzhan.jpg"),
						img:require("../../assets/img1/yszq/jiuzhan.jpg"),
						img1:require("../../assets/img1/yszq/chanping13.jpg"),
						img2:require("../../assets/img1/yszq/chanping16.jpg"),
						img3:require("../../assets/img1/yszq/chanping14.jpg"),
						img4:require("../../assets/img1/yszq/chanping15.jpg")
					},
					{
						i:'22',
						id:'22',
						id1:'22',
						id2:'22',
						id3:'22',
						flag:true,
						img9:require("../../assets/img1/qqly/nanxinghaibao.gif"),
						img:require("../../assets/img1/qqly/qingquneiyhaibao.png"),
						img1:require("../../assets/img1/qqly/chanping17.png"),
						img2:require("../../assets/img1/qqly/chanping17.png"),
						img3:require("../../assets/img1/qqly/chanping17.png"),
						img4:require("../../assets/img1/qqly/chanping17.png")
					},
					{
						i:'272',
						id:'275',
						id1:'273',
						id2:'426',
						id3:'28',
						flag:true,
						img9:require("../../assets/img1/srzq/qijiantao.jpg"),
						img:require("../../assets/img1/srzq/qijiantao.jpg"),
						img1:require("../../assets/img1/srzq/chanping21.jpg"),
						img2:require("../../assets/img1/srzq/chanping22.jpg"),
						img3:require("../../assets/img1/srzq/chanping23.jpg"),
						img4:require("../../assets/img1/srzq/chanping24.jpg")
					}
				]
			],
			pp:[
				{
					img:require("../../assets/img1/pp/BUREX.png"),
					id:'174',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/REIUSJH.png"),
					id:'221',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/HSHUIIA.png"),
					id:'57',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/OUSHI.png"),
					id:'261',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/JIESHIPAI.png"),
					id:'167',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/xuemu.png"),
					id:'22',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/dbshsdlb.png"),
					id:'78',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/9889YEYING.png"),
					id:'49',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/DILIUGAN.png"),
					id:'112',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/LUOGECHENGR.png"),
					id:'245',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/fsgsuj.png"),
					id:'297',
					flag:false
				},
				{
					img:require("../../assets/img1/pp/GENGDUOPINGP.png"),
					id:'',
					flag:false
				},
			],
			f:[
				[
					{
						img:require("../../assets/img1/nxyp/1F.png")
					},
					{
						img:require("../../assets/img1/nxyp1/2F.png")
					},
					{
						img:require("../../assets/img1/byt/3F.png")
					},
					{
						img:require("../../assets/img1/yszq/4F.png")
					},
					{
						img:require("../../assets/img1/qqly/5F.png")
					},
					{
						img:require("../../assets/img1/srzq/6F.png")
					}
				]
			],
			fl:[
					{
						img:require("../../assets/img1/fl/nanxingyongping.png")
					},
					{
						img:require("../../assets/img1/fl/nvxingyongpin.png")
					},
					{
						img:require("../../assets/img1/fl/biyuntao.png")
					},
					{
						img:require("../../assets/img1/fl/yanshizhuqing.png")
					},
					{
						img:require("../../assets/img1/fl/xingxuneiyi.png")
					},
					{
						img:require("../../assets/img1/fl/shuangrenqingqu.png")
					}
			]
		}
	},
	created() {
		this.getCateProduct();
		this.getCate();
    },
	methods:{
		ranking(){
			//指定跳转地址
			this.$router.replace('/ranking')
		},
		//api获取数据
		getCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.category = [];
                    var arr = res.result.cate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.category.push(item);
                        }
						item.flag = false;
                    });
                    this.type = res.result.types;
                }
            }).catch(err=>{
				
			});
			
        },
		getCateProduct() {
            this.$api.getCategory.getProductCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.cate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.cate.push(item);
                        }
						item.flag = false;
                    });
                    this.type = res.result.types;
                }
            }).catch(err=>{
				
			});
			
        },
	}
}
</script>

<style scoped>
.background{
	background: url(../../assets/picture/index/coupon.png) no-repeat;
	width: 590px;
	height: 624px;
	position: absolute;
}
.menu{
	background: url(../../assets/picture/index/menu.png) no-repeat;
	width: 1200px;
	/* height: 36px; */
	/* position: absolute; */
}
.tpbj{
	background: url(../../assets/picture/index/tpbj.png) no-repeat;
	width: 385px;
	height: 534px;
	/* position: absolute; */
	float: left;
	margin-right: 14px;
	margin-bottom: 25px;
}
.btn-buy{
	background: url(../../assets/picture/index/btn.png) no-repeat;
	width: 165px;
	height: 36px;
	line-height: 36px;
	color: #ffffff;
	text-align: center;
	margin-left: 22%;
	font-size: 18px;
}
.right>li{
	cursor: pointer;
	display: inline-block;
	font-size: 14px;
	margin-right: 10px;
}
.right>li>a:hover{
	color: #c6148c;
}
.right>li:last-child{
	cursor: pointer;
	display: inline-block;
	font-size: 14px;
	margin-right: 0px;
}
.right>li:last-child>a{
	color: #c6148c;
}
</style>



// WEBPACK FOOTER //
// src/components/index/Index.vue